var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 13.125H2.13062C1.98958 13.1246 1.87532 13.0104 1.875 12.8694V2.13062C1.87535 1.98958 1.98958 1.87532 2.13062 1.875H4.99998C5.51774 1.875 5.93748 1.45526 5.93748 0.9375C5.93748 0.419736 5.51774 0 4.99998 0H2.13062C0.954463 0.00137695 0.00137695 0.954492 0 2.13062V12.8694C0.00137695 14.0455 0.954463 14.9986 2.13062 15H4.99998C5.51774 15 5.93748 14.5803 5.93748 14.0625C5.93748 13.5447 5.51774 13.125 4.99998 13.125Z",
    fill: "#C95428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1763 5.51124L11.75 3.08686C11.3838 2.7208 10.7901 2.72094 10.4241 3.08718C10.058 3.45342 10.0581 4.04707 10.4244 4.41313L12.5569 6.54501L4.0625 6.5625C3.54474 6.5625 3.125 6.98223 3.125 7.5C3.125 8.01776 3.54474 8.4375 4.0625 8.4375L12.5913 8.42188L10.4244 10.5888C10.0716 10.9677 10.0928 11.561 10.4718 11.9137C10.832 12.249 11.3901 12.2488 11.75 11.9131L14.1744 9.48876C15.2727 8.39042 15.2727 6.60964 14.1744 5.5113L14.1744 5.51127L14.1763 5.51124Z",
    fill: "#C95428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit_icon.3ef0cb9c5b50ccbcda69a1e800ab5fc6.svg";
export { ForwardRef as ReactComponent };